import {
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  LinearProgress,
} from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import md5 from "md5";
import React, { useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import Snackbars from "../../../components/Snackbars/Snackbars";
import AuthStore from "../../../Store/AuthStore";
import "./Login.css";

// import firebase from "services/Firebase";

const styles = (theme) => ({
  container: {
    position: "absolute",
    left: 0,
    right: 0,
    top: "15%",
    bottom: 0,
    margin: "auto",
    maxWidth: 550,
  },
  card: {
    height: "auto",
    display: "flex",
    borderRadius: 8,
    position: "relative",
    boxShadow: "0 2px 10px 0 rgba(0, 0, 0, 0.15)",
  },
  cardContent: {
    width: "100%",
    padding: "40px",
  },
  cardAction: {
    position: "relative",
    height: 40,
  },
  textField: {
    color: "#FFFFFF",
    width: "100%",
  },
  btnLogin: {
    width: 100,
    height: 36,
    borderRadius: 8,
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    margin: "auto",
  },
  progress: {
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 2,
    width: "100%",
  },
});

function FormLogin(props) {
  const [state, setState] = useState({
    formData: { email: "", password: "" },
  });
  const token = "aiueo";
  const [authState, authActions] = AuthStore();

  const { isLoading, status, message } = authState;

  // React.useEffect(() => {
  //     document.getElementById("root").className = "loginBody";
  //     async function getToken() {
  //         const token = await firebase.getPermission();
  //         setToken(token);
  //     }
  //     getToken();
  // }, [firebase, setToken]);

  const handleOnSubmit = (event) => {
    event.preventDefault();
    const { email, password } = state.formData;
    authActions.onSubmitLogin(email, md5(password), token, true);
  };

  const handleChange = (event) => {
    const { formData } = state;
    formData[event.target.name] = event.target.value;
    setState({ formData });
  };

  const onShowSnackbar = () => {
    let title = "";
    if (status === 403) {
      title = "You are off duty. Please contact your supervisor";
    } else {
      title = message;
    }
    return <Snackbars msg={title} />;
  };

  const { classes } = props;

  return (
    <div>
      {status !== 200 ? onShowSnackbar() : null}

      <Container className={classes.container}>
        {process.env.REACT_APP_HOTEL ? (
          <div className="logo-hotel"> </div>
        ) : (
          <div className="logo"></div>
        )}
        <Card className={classes.card}>
          {isLoading ? (
            <LinearProgress className={classes.progress} color="secondary" />
          ) : null}

          <CardContent className={classes.cardContent}>
            <ValidatorForm
              onSubmit={(e) => {
                handleOnSubmit(e);
              }}
            >
              <div className="input-container">
                <TextValidator
                  id="email"
                  label="Email"
                  name="email"
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  value={state.formData.email}
                  validators={["required", "isEmail"]}
                  errorMessages={["email is required", "email is not valid"]}
                  onChange={handleChange}
                  autoFocus
                />
              </div>
              <div className="input-container">
                <TextValidator
                  id="password"
                  label="Password"
                  name="password"
                  className={classes.textField}
                  margin="normal"
                  value={state.formData.password}
                  variant="outlined"
                  validators={["required"]}
                  errorMessages={["password is required"]}
                  type="password"
                  onChange={handleChange}
                />
              </div>
              <CardActions className={classes.cardAction}>
                <Button
                  variant="contained"
                  color="secondary"
                  type="submit"
                  className={classes.btnLogin}
                >
                  LOGIN
                </Button>
              </CardActions>
            </ValidatorForm>
          </CardContent>
        </Card>
      </Container>
    </div>
  );
}

export default withStyles(styles)(FormLogin);
